import { CoordinationProvider as ServerCoordinationProvider } from 'server/models/CoordinationProvider';

export * from 'server/models/CoordinationProvider';

export class CoordinationProvider extends ServerCoordinationProvider {
    /** A comparator function for two CoordinationProviders belonging to the same Coordination. */
    // NOTE: Keep in sync with PortCall.Models\CoordinationCards\CoordinationProvider.cs (search
    // "DisplayOrderExtensions").
    static DisplayOrder(p1 : CoordinationProvider, p2 : CoordinationProvider) {
        let cmp : number;
        return (cmp = p1.DisplayOrder() - p2.DisplayOrder()) === 0 ?
            // If DisplayOrder matches, fallback to ProviderId for a deterministic sort.
            p1.ProviderId() - p2.ProviderId() :
            cmp;
    }
}



// WEBPACK FOOTER //
// ./data/models/CoordinationProvider.ts